.section {
  padding: 76px 0;
  background: var(--color-primary-sand-100); /* PRIMARY_SAND_100 (cream) */
}

.series {
  display: flex;
  flex-direction: column;
  gap: 56px;
}

.serie__head {
  display: flex;
  gap: 18px;
  align-items: flex-start;
  margin-bottom: 24px;
  padding-bottom: 22px;
  border-bottom: 2px solid var(--color-primary-sand-200); /* PRIMARY_SAND_200 */
}

.serie__num {
  width: 52px;
  height: 52px;
  border: 2px solid var(--color-primary-grey-900); /* PRIMARY_GREY_900 */
  border-radius: 13px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex: none;
  font-family: var(--plume-font-display, sofia-pro, sans-serif);
  font-size: 18px;
  font-weight: 900;
}

.serie__title {
  font-family: var(--plume-font-display, sofia-pro, sans-serif);
  font-size: 23px; /* HEADING_S */
  font-weight: 900;
  letter-spacing: -0.01em;
  color: var(--color-primary-grey-900); /* PRIMARY_GREY_900 */
  margin: 0 0 4px;
}

.serie__desc {
  font-size: 16px; /* COPY_M */
  line-height: 1.5;
  color: var(--color-primary-sand-900); /* PRIMARY_SAND_900 (text-2) */
  max-width: 520px;
  margin: 0;
}

.serie__grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(240px, 1fr));
  gap: 24px;
}

/* Sub-grouping within a series (customisable vs ready-made stickers). */
.subgroup + .subgroup {
  margin-top: 30px;
}

.subgroup__label {
  font-size: 13px; /* HEADING_5XS */
  font-weight: 800;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  color: var(--color-primary-grey-900); /* PRIMARY_GREY_900 */
  margin: 0 0 14px;
}

/* Yellow "Ulule Connect" callout — same treatment as the Press page's newsletter band. */
.connect {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 16px;
  margin-top: 56px;
  background: var(--color-complementary-yellow); /* COMPLEMENTARY_YELLOW (accent) */
  border: 2px solid var(--color-primary-grey-900); /* PRIMARY_GREY_900 */
  border-radius: 18px;
  padding: 26px 32px;
  text-align: center;
  box-shadow: var(--plume-shadow-newsletter, 1px 2px 10px 0 rgba(89, 84, 78, 0.12));
}

.connect ::selection {
  background: var(--color-primary-grey-900); /* PRIMARY_GREY_900 */
  color: var(--color-complementary-yellow); /* COMPLEMENTARY_YELLOW */
}

.connect__icon {
  flex: none;
  width: 44px;
  height: 44px;
  border-radius: 50%;
  background: var(--color-primary-grey-900); /* PRIMARY_GREY_900 */
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--color-complementary-yellow);
}

.connect__icon svg {
  width: 21px;
  height: 21px;
}

.connect__text {
  font-size: 18px;
  font-weight: 600;
  color: var(--color-primary-grey-900); /* PRIMARY_GREY_900 */
  margin: 0;
}

.connect__text a {
  color: var(--color-primary-grey-900);
  font-weight: 800;
  text-decoration: underline;
  text-underline-offset: 3px;
  text-decoration-thickness: 2px;
}

@media (max-width: 560px) {
  .serie__grid {
    grid-template-columns: 1fr 1fr;
  }

  .connect {
    flex-direction: column;
  }
}
